import { OIDCConfiguration } from '../Common/TypeDefinitions';

export interface BaseTableEntry {
	readonly referenceUri: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface StoreConfigurationTableKey extends BaseTableEntry {}

export interface StoreConfigurationTableEntry extends StoreConfigurationTableKey {
	readonly tokenServiceURL: string;
	readonly oidcConfiguration: OIDCConfiguration | null;
	readonly authDomain: string;
	readonly acrValues?: string | null;
	readonly promptLoginEnabled?: boolean;
	readonly storeType?: StoreType;
	readonly defaultGatewayLocation?: string;
	readonly storeName?: string;
	readonly beacon?: string;
}

export enum StoreType {
	Cloud = 'SERVER_TYPE_CLOUD',
	StoreFront = 'AM_SERVER_TYPE_STOREFRONT',
	AdvancedGateway = 'AM_SERVER_TYPE_GATEWAY_ADVANCED',
	BasicGateway = 'AM_SERVER_TYPE_GATEWAY_BASIC',
	Gateway = 'AM_SERVER_TYPE_GATEWAY',
	Unknown = 'AM_SERVER_TYPE_UNKNOWN',
}

export enum NetworkLocation {
	Deciding = 'NetworkLocationDeciding',
	Inside = 'NetworkLocationLAN',
	Outside = 'NetworkLocationOutside',
	None = 'NetworkLocationNone',
	Vpn = 'NetworkLocationVPN',
	Hotspot = 'NetworkLocationHotspot',
}
